import React, { createContext, useContext, useMemo, useState } from 'react';

const STORAGE_KEY = 'portal.viewMode';

const ViewModeContext = createContext({
  viewMode: 'basic',
  isAdvanced: false,
  setViewMode: () => {},
});

export function ViewModeProvider({ children }) {
  const [viewMode, setViewModeState] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored === 'advanced' ? 'advanced' : 'basic';
    } catch {
      return 'basic';
    }
  });

  const setViewMode = (mode) => {
    const next = mode === 'advanced' ? 'advanced' : 'basic';
    setViewModeState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // ignore storage errors
    }
  };

  const value = useMemo(
    () => ({
      viewMode,
      isAdvanced: viewMode === 'advanced',
      setViewMode,
    }),
    [viewMode]
  );

  return <ViewModeContext.Provider value={value}>{children}</ViewModeContext.Provider>;
}

export function useViewMode() {
  return useContext(ViewModeContext);
}

export default ViewModeContext;
